import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { ActionButton } from 'ui/actionButton/ActionButton';
import { usePermissions } from 'hooks/usePermissions/usePermissions';

import { DeleteGroupTerminalPermissionProps } from './DeleteGroupTerminalPermission.types';

export const DeleteGroupTerminalPermission = ({
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
}: DeleteGroupTerminalPermissionProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();

  return (
    <>
      <ActionButton type="delete" onClick={onModalOpen} disabled={!perms?.UPR_GRUPOWE?.edit} />

      <ActionModal
        header={formatMessage({ id: AppMessages['group.reader.permission.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['group.reader.permission.delete.button'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['group.reader.permission.delete.subtitle'] })}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['group.reader.permission.delete.text'] })}</ActionModal.Text>

        <ActionModal.Text variant="subtitle1">
          {formatMessage({ id: AppMessages['common.irreversibleAction'] })}
        </ActionModal.Text>
      </ActionModal>
    </>
  );
};
